export class Test {
	/** @deprecated Use something else instead */
	public get foo(): number {
		return 42;
	}
}
